export default __webpack_public_path__ + "static/media/add_circle.64896319.svg";